import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { useLeadModal } from "../components/LeadModal";

export const ImpactBanner = () => {
  const { openModal } = useLeadModal();

  return (
    <section className="relative px-5 py-10 sm:px-8" data-testid="impact-banner-section">
      <Reveal>
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-petrol px-8 py-20 text-center sm:px-12 lg:py-28">
          <div className="glow-brand-strong pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full" />
          <div className="glow-brand-strong pointer-events-none absolute -bottom-32 -right-32 h-96 w-96 rounded-full" />
          <div className="relative">
            <p className="font-mono text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-brand-400">
              Não empurre com a barriga
            </p>
            <h2 className="mx-auto mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
              Tem um problema no imóvel?
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg">
              Não deixe uma pequena demanda virar uma grande dor de cabeça.
            </p>
            <button
              onClick={() => openModal()}
              data-testid="impact-cta-button"
              className="group mt-10 inline-flex h-14 items-center gap-3 rounded-full bg-white px-10 font-display text-base font-bold text-petrol shadow-[0_20px_50px_-12px_rgba(255,255,255,0.35)] transition-[background-color,color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:bg-brand hover:text-white"
            >
              Resolver agora
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
